import SVGDownload from "components/_common/icons/vdm/SVGDownload";
import React, { useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import {
	CartesianGrid,
	LabelList,
	Legend,
	Line,
	LineChart,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
import { Dispatch } from "redux";
import { IStore } from "redux/store";
import Select, { components } from "react-select";
import { IOption } from "redux/app/vdmdashboard/@types";
import SVGFilter from "components/_common/icons/vdm/SVGFilter";
import ToggleSwitch from "../../_elements/ToggleSwitch";

type IChartDataPoint = {
	date: string;
	pressure?: number;
	methane?: number;
	topTemp?: number;
	midTemp?: number;
	bottomTemp?: number;
};

const chartData: IChartDataPoint[] = [
	{
		date: "01 Jan",
		pressure: 76.1,
		methane: 0.66,
		topTemp: -111.2,
		midTemp: -122.1,
		bottomTemp: -133.5,
	},
	{
		date: "02 Jan",
		pressure: 76.5,
		methane: 0.68,
		topTemp: -111.5,
		midTemp: -122.5,
		bottomTemp: -133.8,
	},
	{
		date: "03 Jan",
		pressure: 77.0,
		methane: 0.69,
		topTemp: -111.0,
		midTemp: -122.2,
		bottomTemp: -133.2,
	},
	{
		date: "04 Jan",
		pressure: 77.2,
		methane: 0.69,
		topTemp: -111.3,
		midTemp: -122.8,
		bottomTemp: -134.0,
	},
	{
		date: "05 Jan",
		pressure: 78.0,
		methane: 0.7,
		topTemp: -110.8,
		midTemp: -121.8,
		bottomTemp: -133.0,
	},
	{
		date: "06 Jan",
		pressure: 77.3,
		methane: 0.89,
		topTemp: -111.6,
		midTemp: -122.7,
		bottomTemp: -134.1,
	},
	{
		date: "07 Jan",
		pressure: 77.5,
		methane: 0.7,
		topTemp: -111.1,
		midTemp: -122.0,
		bottomTemp: -133.4,
	},
	{
		date: "08 Jan",
		pressure: 78.3,
		methane: 0.69,
		topTemp: -110.5,
		midTemp: -121.5,
		bottomTemp: -132.9,
	},
	{
		date: "09 Jan",
		pressure: 78.2,
		methane: 0.7,
		topTemp: -110.9,
		midTemp: -121.9,
		bottomTemp: -133.6,
	},
	{
		date: "10 Jan",
		pressure: 78.6,
		methane: 0.73,
		topTemp: -111.4,
		midTemp: -122.4,
		bottomTemp: -133.9,
	},
	{
		date: "11 Jan",
		pressure: 76.4,
		methane: 0.72,
		topTemp: -111.7,
		midTemp: -122.9,
		bottomTemp: -134.2,
	},
	{
		date: "12 Jan",
		pressure: 76.8,
		methane: 0.68,
		topTemp: -112.0,
		midTemp: -123.0,
		bottomTemp: -134.5,
	},
	{
		date: "13 Jan",
		pressure: 76.0,
		methane: 0.6,
		topTemp: -112.2,
		midTemp: -123.5,
		bottomTemp: -135.0,
	},
	{
		date: "14 Jan",
		pressure: 75.8,
		methane: 0.57,
		topTemp: -111.8,
		midTemp: -122.8,
		bottomTemp: -134.3,
	},
	{
		date: "15 Jan",
		pressure: 75.5,
		methane: 0.56,
		topTemp: -111.3,
		midTemp: -122.3,
		bottomTemp: -133.7,
	},
	{
		date: "16 Jan",
		pressure: 75.0,
		methane: 0.5,
		topTemp: -111.9,
		midTemp: -123.2,
		bottomTemp: -134.8,
	},
	{
		date: "17 Jan",
		pressure: 75.6,
		methane: 0.55,
		topTemp: -111.2,
		midTemp: -122.2,
		bottomTemp: -133.5,
	},
	{
		date: "18 Jan",
		pressure: 77.9,
		methane: 0.71,
		topTemp: -110.7,
		midTemp: -121.7,
		bottomTemp: -133.1,
	},
	{
		date: "19 Jan",
		pressure: 76.3,
		methane: 0.59,
		topTemp: -111.5,
		midTemp: -122.5,
		bottomTemp: -134.0,
	},
	{
		date: "20 Jan",
		pressure: 76.4,
		methane: 0.59,
		topTemp: -111.6,
		midTemp: -122.6,
		bottomTemp: -134.2,
	},
	{
		date: "21 Jan",
		pressure: 74.3,
		methane: 0.43,
		topTemp: -112.5,
		midTemp: -123.8,
		bottomTemp: -135.2,
	},
	{
		date: "22 Jan",
		pressure: 74.4,
		methane: 0.44,
		topTemp: -112.3,
		midTemp: -123.3,
		bottomTemp: -134.7,
	},
	{
		date: "23 Jan",
		pressure: 75.0,
		methane: 0.48,
		topTemp: -112.0,
		midTemp: -123.0,
		bottomTemp: -134.4,
	},
	{
		date: "24 Jan",
		pressure: 75.8,
		methane: 0.57,
		topTemp: -111.4,
		midTemp: -122.4,
		bottomTemp: -133.8,
	},
	{
		date: "25 Jan",
		pressure: 76.3,
		methane: undefined,
		topTemp: -111.0,
		midTemp: -122.0,
		bottomTemp: -133.3,
	},
	{
		date: "26 Jan",
		pressure: 76.7,
		methane: 0.64,
		topTemp: -110.8,
		midTemp: -121.8,
		bottomTemp: -133.1,
	},
	{
		date: "27 Jan",
		pressure: 76.9,
		methane: 0.65,
		topTemp: -110.6,
		midTemp: -121.6,
		bottomTemp: -132.9,
	},
	{
		date: "28 Jan",
		pressure: 77.7,
		methane: 0.67,
		topTemp: -110.4,
		midTemp: -121.4,
		bottomTemp: -132.7,
	},
	{
		date: "29 Jan",
		pressure: 77.9,
		methane: 0.71,
		topTemp: -110.2,
		midTemp: -121.2,
		bottomTemp: -132.5,
	},
	{
		date: "30 Jan",
		pressure: 78.3,
		methane: 0.74,
		topTemp: -110.0,
		midTemp: -121.0,
		bottomTemp: -132.3,
	},
	{
		date: "31 Jan",
		pressure: 78.5,
		methane: undefined,
		topTemp: -109.8,
		midTemp: -120.8,
		bottomTemp: -132.1,
	},
	{
		date: "01 Feb",
		pressure: 78.4,
		methane: undefined,
		topTemp: -110.1,
		midTemp: -121.1,
		bottomTemp: -132.4,
	},
	{
		date: "02 Feb",
		pressure: 78.2,
		methane: 0.68,
		topTemp: -110.3,
		midTemp: -121.3,
		bottomTemp: -132.6,
	},
];

const lineConfigs = [
	{
		name: "Pressure (bar g)",
		dataKey: "pressure",
		color: "#667085",
		switchTitle: "Pressure",
	},
	{
		name: "Methane Number",
		dataKey: "methane",
		color: "#47CD89",
		switchTitle: "Methane No.",
	},
	{
		name: "Top Temp. (°C)",
		dataKey: "topTemp",
		color: "#FAC515",
		switchTitle: "Top Temp.",
	},
	{
		name: "Mid Temp. (°C)",
		dataKey: "midTemp",
		color: "#36BFFA",
		switchTitle: "Middle Temp.",
	},
	{
		name: "Bottom Temp. (°C)",
		dataKey: "bottomTemp",
		color: "#528BFF",
		switchTitle: "Bottom Temp.",
	},
];

const CustomizedLabel = (props: any) => {
	const { x, y, stroke, value } = props;
	if (value === null || value === undefined) return null;
	return (
		<text x={x} y={y} dy={-10} fill={stroke} fontSize={10} textAnchor="middle">
			{value}
		</text>
	);
};

type OwnProps = {};
type TankTrendsChartProps = PropsFromRedux & OwnProps;
function TankTrendsChart(props: TankTrendsChartProps) {
	const tankOptions = [
		{
			label: "Tank 01",
			value: "Tank 01",
		},
		{
			label: "Tank 02",
			value: "Tank 02",
		},
		{
			label: "Tank 03",
			value: "Tank 03",
		},
	];
	const [selectedTank, setSelectedTank] = useState<IOption | undefined>(
		tankOptions[0]
	);
	const [currentLineConfigs, setCurrentLineConfigs] = useState(lineConfigs);
	const initialMetricsToShow = lineConfigs?.reduce((acc, curr) => {
		acc[curr.dataKey] = true;
		return acc;
	}, {} as Record<string, boolean>);
	const [metricsToShow, setMetricsToShow] =
		useState<Record<string, boolean>>(initialMetricsToShow);

	return (
		<div className="bg-white p-4 rounded-md shadow-md border border-gray-300 mt-4">
			<div className="flex items-center justify-between rounded mb-4">
				<h3 className="text-xl text-gray-700 font-medium">Tank Trends</h3>
				{/* TODO: Can be reused for LNG Consumption */}
				<div className=" flex items-center gap-x-2">
					<div className="flex items-center gap-x-2">
						{Object.keys(metricsToShow)?.map((metric) => {
							const isChecked = metricsToShow[metric];
							const metricDetails = lineConfigs?.find(
								(lc) => lc.dataKey === metric
							);
							return (
								<ToggleSwitch
									key={metric}
									id={metric}
									isChecked={isChecked}
									label={metricDetails?.switchTitle ?? ""}
									handleToggle={(isChecked: boolean) => {
										const updatedMetricsToShow = {
											...metricsToShow,
											[metric]: isChecked,
										};
										setMetricsToShow(updatedMetricsToShow);
										const updatedLineConfigs = lineConfigs?.filter(
											(lc) => updatedMetricsToShow[lc.dataKey]
										);
										setCurrentLineConfigs(updatedLineConfigs);
									}}
								/>
							);
						})}
					</div>
					{/* TODO: can extract it out as a component.  */}
					<Select<IOption>
						value={selectedTank}
						onChange={(option) => option && setSelectedTank(option)}
						options={tankOptions}
						isSearchable={false}
						components={{
							Option: (props) => {
								return (
									<components.Option {...props}>
										{props.data.label}
									</components.Option>
								);
							},
							SingleValue: (props) => {
								return (
									<components.SingleValue {...props}>
										<div className="flex items-center">
											<span className="px-2 pl-1 text-sm text-gray-600">
												<SVGFilter />
											</span>
											<span className="text-sm">{props?.data.label}</span>
										</div>
									</components.SingleValue>
								);
							},
						}}
						classNames={{
							control: ({ isFocused }) =>
								`min-h-0 h-10 border border-gray-300 rounded-lg shadow-none hover:border-gray-400 ${
									isFocused ? "border-blue-500 ring-1 ring-blue-500" : ""
								}`,
							valueContainer: () => "p-0 pl-1",
							indicatorSeparator: () => "hidden",
							dropdownIndicator: () => "p-2",
							menu: () =>
								"mt-1 p-1 rounded-lg border border-gray-200 shadow-lg",
							option: ({ isFocused, isSelected }) =>
								`flex items-center cursor-pointer px-3 py-2 text-sm rounded-md ${
									isFocused ? "bg-blue-50" : "bg-white"
								} ${
									isSelected
										? "bg-blue-100 text-blue-800 font-semibold"
										: "text-gray-700"
								}`,
						}}
					/>
					<div className="p-2 rounded border border-gray-300">
						<SVGDownload />
					</div>
				</div>
			</div>
			<div style={{ width: "100%", height: 450 }}>
				<ResponsiveContainer>
					<LineChart
						data={chartData}
						margin={{
							top: 20,
							right: 30,
							left: 20,
							bottom: 5,
						}}
					>
						<CartesianGrid
							strokeDasharray="3 3"
							stroke="#e0e0e0"
							vertical={true}
							horizontal={true}
						/>
						<XAxis
							dataKey="date"
							tick={{ fontSize: 12, fill: "#666" }}
							axisLine={{ stroke: "#e0e0e0" }}
							tickLine={{ stroke: "#e0e0e0" }}
						/>
						<YAxis
							tick={{ fontSize: 12, fill: "#666" }}
							axisLine={{ stroke: "#e0e0e0" }}
							tickLine={{ stroke: "#e0e0e0" }}
						/>
						{/* Can use customized tooltip, for now it was not needed. */}
						<Tooltip
							contentStyle={{
								backgroundColor: "rgba(255, 255, 255, 0.95)",
								border: "1px solid #ccc",
								fontSize: 12,
								borderRadius: "0.5rem",
							}}
						/>
						<Legend
							wrapperStyle={{ paddingBottom: "20px" }}
							verticalAlign="top"
							iconType="square"
							align="right"
						/>

						{currentLineConfigs.map((line) => (
							<Line
								key={line.dataKey}
								type="monotone"
								dataKey={line.dataKey}
								stroke={line.color}
								strokeWidth={2}
								dot={{ r: 3, fill: line.color }}
								activeDot={{ r: 3 }}
								connectNulls // This ensures the line continues over null data points
							>
								<LabelList
									dataKey={line.dataKey}
									content={<CustomizedLabel />}
								/>
							</Line>
						))}
					</LineChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(TankTrendsChart);
